// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset enxuto e tipografia base. */

*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body,
#raiz {
  height: 100%;
}

body {
  margin: 0;
  background: var(--fundo-principal);
  color: var(--tinta);
  font-family: var(--fonte-ui);
  font-size: var(--texto-md);
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}

h1,
h2,
h3,
p,
figure {
  margin: 0;
}

button,
input,
select,
textarea {
  font: inherit;
  color: inherit;
}

:focus-visible {
  outline: 2px solid var(--foco);
  outline-offset: 2px;
}

/* Rótulo disponível a leitores de tela, sem ocupar espaço visual. */
.sr-apenas {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}

::selection {
  background: var(--realce-fraco);
}

* {
  scrollbar-width: thin;
  scrollbar-color: var(--linha-forte) transparent;
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/base.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,mBAAmB;EACnB,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;;;EAKE,SAAS;AACX;;AAEA;;;;EAIE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,oEAAoE;AACpE;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF","sourcesContent":["/* Reset enxuto e tipografia base. */\r\n\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml,\r\nbody,\r\n#raiz {\r\n  height: 100%;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  background: var(--fundo-principal);\r\n  color: var(--tinta);\r\n  font-family: var(--fonte-ui);\r\n  font-size: var(--texto-md);\r\n  line-height: 1.5;\r\n  -webkit-font-smoothing: antialiased;\r\n  text-rendering: optimizeLegibility;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\np,\r\nfigure {\r\n  margin: 0;\r\n}\r\n\r\nbutton,\r\ninput,\r\nselect,\r\ntextarea {\r\n  font: inherit;\r\n  color: inherit;\r\n}\r\n\r\n:focus-visible {\r\n  outline: 2px solid var(--foco);\r\n  outline-offset: 2px;\r\n}\r\n\r\n/* Rótulo disponível a leitores de tela, sem ocupar espaço visual. */\r\n.sr-apenas {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  margin: -1px;\r\n  overflow: hidden;\r\n  clip-path: inset(50%);\r\n  white-space: nowrap;\r\n  border: 0;\r\n}\r\n\r\n::selection {\r\n  background: var(--realce-fraco);\r\n}\r\n\r\n* {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: var(--linha-forte) transparent;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n    transition-duration: 0.01ms !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
